import styled from 'styled-components';
import { getSpacing, pageWidth } from 'stylesheet';
var Container = styled.div.withConfig({
  displayName: "ContentSidebarstyle__Container",
  componentId: "sc-12trtvs-0"
})(["position:fixed;top:50%;left:calc(50% + ", "px + ", ");display:flex;flex-direction:column;transform:translate(0,-50%);"], pageWidth.small / 2, getSpacing(2));
export { Container };